import "./GoogleForm.scss";

function GoogleForm() {
  return (
    <div className="google-form">
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://docs.google.com/forms/d/e/1FAIpQLScokLn5BA3IjiXZ37g1oaY7cWl7_bx4RzLCbFNcSa3XspcS0w/viewform?usp=sf_link"
      >
        Questions/feedback? Click here
      </a>
    </div>
  );
}

export default GoogleForm;
